import React from 'react';
import { IconRotatableProps, colourString } from '@keplerco/core';

export default function CircleChevronIcon(props: IconRotatableProps) {
  const size = `${props.size ?? 20}px`;
  const tone = colourString(props.tone ?? 'accent-3');
  const rotation = props.rotation ?? 1;
  const rotationDegrees = (rotation - 1) * 90;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 20 20" fill="none" style={{ transform: `rotate(${rotationDegrees}deg)` }}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 9.75C20 15.1348 15.6348 19.5 10.25 19.5C4.86522 19.5 0.5 15.1348 0.5 9.75C0.5 4.36522 4.86522 0 10.25 0C15.6348 0 20 4.36522 20 9.75ZM2 9.75C2 14.3063 5.69365 18 10.25 18C14.8063 18 18.5 14.3063 18.5 9.75C18.5 5.19365 14.8063 1.5 10.25 1.5C5.69365 1.5 2 5.19365 2 9.75Z"
        fill={tone}
      />
      <path d="M6.5 11L10.25 7.5L14 11" stroke={tone} strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
